import type { GetStaticProps, NextPage } from 'next'
import React, { useEffect } from 'react';
import AboutUs from '../components/AboutUs';
import { MetaTagsComp } from '../components/MetaTagsComp';
import fetchUtil from '../utils/fetchUtil';

const Aboutus: NextPage = (props: any) => {
  const { meta } = props?.aboutusData
  useEffect(() => {
    const customStyle = document.documentElement.style
    customStyle.setProperty('--navbar-color', '#6C48F0');
    customStyle.setProperty('--navbar-menu-color', '#ffffff')
  }, [])
  return (
    <>
      {meta && <MetaTagsComp {...meta} />}
      <AboutUs {...props} />
    </>
  )
}

export const getStaticProps: GetStaticProps = async (context) => {
  const footerData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/footer`, 'GET', {}, '', false)
  const aboutusData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/aboutus`, 'GET', {}, '', false)
  return {
    props: { footerData, aboutusData }
  };
}

export default Aboutus